import { c as _c } from "react/compiler-runtime";
import { useButton } from "@website/ui/button/button.hook";
import styles from "@website/ui/button/button.module.scss";
import { ButtonPropertiesType } from "@website/ui/button/button.types";
import { Loading } from "@website/ui/loading";
import omit from "lodash-es/omit";
import Link from "next/link";
import { FC } from "react";
export const Button: FC<ButtonPropertiesType> = properties => {
  const $ = _c(28);
  const {
    children,
    className,
    color: t0,
    disabled,
    EndIcon,
    fullWidth,
    loading,
    loadingWithText,
    role,
    size: t1,
    StartIcon,
    variant: t2,
    text,
    replace,
    equalDimension,
    divButtonType,
    loadingColor: t3
  } = properties;
  const color = t0 === undefined ? "primary" : t0;
  const size = t1 === undefined ? "medium" : t1;
  const variant = t2 === undefined ? "contained" : t2;
  const loadingColor = t3 === undefined ? "white" : t3;
  const {
    buttonProps,
    linkProps,
    divButtonProps
  } = useButton(properties);
  const classNames = `${styles.button} ${styles[variant]} ${styles[color]} ${disabled ? styles.disabled : ""} ${styles[size]} ${fullWidth ? styles["full-width"] : ""} ${equalDimension ? styles["equal-dimension"] : ""} ${className ?? ""}`;
  let t4;
  if ($[0] !== EndIcon || $[1] !== StartIcon || $[2] !== children || $[3] !== loading || $[4] !== loadingColor || $[5] !== loadingWithText || $[6] !== size || $[7] !== text) {
    t4 = loading ? children && loadingWithText ? <Loading color="primary" size="xs"><span className="mx-1">{children}</span></Loading> : <Loading color={loadingColor} /> : <>{StartIcon ? <span className={`${styles.icon} ${size === "x-small" ? styles["icon-large"] : children ? styles["icon-small"] : styles["icon-medium"]}`}>{StartIcon}</span> : null}{text ? <div className={styles.text}>{text}</div> : null}{children ? <span className="mx-1">{children}</span> : null}{EndIcon ? <span className={`${styles.icon} ${size === "x-small" ? styles["icon-large"] : children ? styles["icon-small"] : styles["icon-medium"]}`}>{EndIcon}</span> : null}</>;
    $[0] = EndIcon;
    $[1] = StartIcon;
    $[2] = children;
    $[3] = loading;
    $[4] = loadingColor;
    $[5] = loadingWithText;
    $[6] = size;
    $[7] = text;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const elements = t4;
  if (role === "link") {
    let t5;
    if ($[9] !== linkProps) {
      t5 = omit(linkProps, "prefetch");
      $[9] = linkProps;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    let t6;
    if ($[11] !== classNames || $[12] !== elements || $[13] !== t5) {
      t6 = <a {...t5} className={classNames}>{elements}</a>;
      $[11] = classNames;
      $[12] = elements;
      $[13] = t5;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    return t6;
  }
  if (role === "next-link") {
    const t5 = replace ?? false;
    let t6;
    if ($[15] !== classNames || $[16] !== elements || $[17] !== linkProps || $[18] !== t5) {
      t6 = <Link {...linkProps} className={classNames} replace={t5}>{elements}</Link>;
      $[15] = classNames;
      $[16] = elements;
      $[17] = linkProps;
      $[18] = t5;
      $[19] = t6;
    } else {
      t6 = $[19];
    }
    return t6;
  }
  if (divButtonType) {
    let t5;
    if ($[20] !== classNames || $[21] !== divButtonProps || $[22] !== elements) {
      t5 = <div {...divButtonProps} className={classNames}>{elements}</div>;
      $[20] = classNames;
      $[21] = divButtonProps;
      $[22] = elements;
      $[23] = t5;
    } else {
      t5 = $[23];
    }
    return t5;
  }
  let t5;
  if ($[24] !== buttonProps || $[25] !== classNames || $[26] !== elements) {
    t5 = <button {...buttonProps} className={classNames}>{elements}</button>;
    $[24] = buttonProps;
    $[25] = classNames;
    $[26] = elements;
    $[27] = t5;
  } else {
    t5 = $[27];
  }
  return t5;
};